// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rxMxj","colMin":"styles_colMin__ZejZo"};